import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { PartnersActionTypes, ResponseDataRequests } from './types'

type Options = {
  page?: number
  request_agency_ids?: string[]
  request_ids?: string[]
}

export const getPartners = createAction(
  PartnersActionTypes.GET_PARTNERS,
  action =>
    (options: Options = { page: 1, request_ids: [], request_agency_ids: [] }) =>
      action({ options })
)

export const getPartnersFailure = createAction(
  PartnersActionTypes.GET_PARTNERS_FAILURE,
  action => (message: string) => action({ message })
)

export const getPartnersSuccess = createAction(
  PartnersActionTypes.GET_PARTNERS_SUCCESS,
  action =>
    ({ partners }: ResponseDataRequests) =>
      action({ partners })
)

export const sendPartner = createAction(
  PartnersActionTypes.SEND_PARTNER,
  action =>
    (partner: {
      partner_id: Id
      partner_number: Number
      city_id: Id
      partner_type: String
      partner_name: String
      partner_description: String
      partner_vat_number: String
      latitude: String
      longitude: String
      address: String
      quarter: String
      address_number: String
      zip_code: String
      additional_info: String
      active: 'true' | 'false'
    }) =>
      action({ partner })
)

export const sendPartnerFailure = createAction(
  PartnersActionTypes.SEND_PARTNER_FAILURE,
  action => (message: string) => action({ message })
)

export const sendPartnerSuccess = createAction(
  PartnersActionTypes.SEND_PARTNER_SUCCESS,
  action =>
    ({ response }: any) =>
      action({ response })
)
